import { useEffect } from "react";
import Preloader from "../../common/Preloader";

export default function ExternalRedirect({ href }) {
  useEffect(() => {
    if (href) window.location.href = href;
  }, [href]);

  return <Preloader />;
}
